import type { ReactElement } from 'react';
import { MDText } from 'i18n-react';

import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { useCypressData } from 'Utilities/hooks/useCypressData';

import LocalTexts from '../Title/Title.texts';

import styles from './DataDisclaimer.module.scss';

const LocalT = new MDText(LocalTexts);

export const DataDisclaimer = (): ReactElement => {
	const [cypressIds, applyCypressDataId] = useCypressData();
	return (
		<div className={styles.disclaimerContainer} {...applyCypressDataId(cypressIds.text.insights.results.disclaimer)}>
			<InfoBox content={String(LocalT.translate('dataDisclaimer'))} size="small" variant="info" />
		</div>
	);
};
